export default __webpack_public_path__ + "9d38e1fd32b5b054081332535af2ffad.png";